// src/components/Experiment/PlateToolsContainer.js
import React from 'react';
import { Button, ButtonGroup, Badge } from 'react-bootstrap';

const PlateToolsContainer = ({
  onSetGrid,
  onAddRowColumn,
  onDeleteRowColumn,
  onSelectAll,
  gridSize,
  samplesCount,
  selectedCellsCount
}) => {
  return (
    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
      <div className="d-flex align-items-center gap-3">
        <div className="d-flex align-items-center gap-2">
          <span className="text-muted small">Grid:</span>
          <Badge bg="secondary">{gridSize}</Badge>
        </div>

        <div className="d-flex align-items-center gap-2">
          <span className="text-muted small">Samples:</span>
          <Badge bg="primary">{samplesCount}</Badge>
        </div>

        {selectedCellsCount > 0 && (
          <div className="d-flex align-items-center gap-2">
            <span className="text-muted small">Selected:</span>
            <Badge bg="info">{selectedCellsCount}</Badge>
          </div>
        )}
      </div>

      <ButtonGroup size="sm">
        <Button variant="outline-primary" onClick={onSetGrid}>
          <i className="bi bi-grid me-1"></i>
          Set Grid
        </Button>

        <Button variant="outline-success" onClick={onAddRowColumn}>
          <i className="bi bi-plus-square me-1"></i>
          Add
        </Button>

        <Button variant="outline-danger" onClick={onDeleteRowColumn}>
          <i className="bi bi-dash-square me-1"></i>
          Delete
        </Button>

        <Button variant="outline-info" onClick={onSelectAll}>
          <i className="bi bi-check-all me-1"></i>
          Select All
        </Button>
      </ButtonGroup>
    </div>
  );
};

export default PlateToolsContainer;